module.exports = __webpack_public_path__ + "static/img/smoke_i.124e56f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smoke_i.png
// module id = bwDp
// module chunks = 208